import { ValidationsService } from '@core/services/validations.service';

export const CONSTANT_CONFIG = [
  {
    name: 'DaysToUpdate',
    value: [ValidationsService.isInvalidNumberValidator]
  },
  {
    name: 'YearsToUpdate',
    value: [ValidationsService.isInvalidNumberValidator]
  },
  {
    name: 'CashIn',
    value: [ValidationsService.isVariableValueValidator]
  },
  {
    name: 'CashOut',
    value: [ValidationsService.isVariableValueValidator]
  }
];
